import * as Yup from "yup";

export const formValidationSchema = Yup.object().shape({
  tgl_form_checklist: Yup.string().required("Tgl wajib di isi"),
});
